import { defineMessages } from 'react-intl';

export const skinAnalyserMessages = defineMessages({
  skinAnalyserTitle: {
    id: 'pd.skinAnalyserTitle',
    defaultMessage: 'Okamžitá diagnostika pleti s {brand}',
  },
  skinAnalyserDescriptionVariant1: {
    id: 'pd.skinAnalyserDescriptionVariant1',
    defaultMessage: 'Zjistěte, které produkty jsou vhodné právě pro vás.',
  },
  skinAnalyserDescriptionVariant2: {
    id: 'pd.skinAnalyserDescriptionVariant2',
    defaultMessage:
      'Zjistěte, které produkty jsou pro vás vhodné. Díky krátkému dotazníku a screeningu tváře.',
  },
  skinAnalyserRunDiagnostic: {
    id: 'pd.skinAnalyserRunDiagnostic',
    defaultMessage: 'Spustit diagnostiku',
  },
});
